var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#F6DDCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8393 15.0625C6.09384 13.8058 5.83277 12.3202 6.10512 10.8847C6.37747 9.44918 7.1645 8.16245 8.31843 7.26614C9.47235 6.36983 10.9138 5.92559 12.3721 6.01684C13.8304 6.1081 15.2052 6.72857 16.2384 7.76175C17.2715 8.79492 17.892 10.1697 17.9833 11.628C18.0745 13.0863 17.6303 14.5277 16.734 15.6817C15.8377 16.8356 14.551 17.6226 13.1154 17.895C11.6799 18.1674 10.1943 17.9063 8.93766 17.1608L8.93767 17.1608L6.86539 17.7529C6.77965 17.7774 6.68892 17.7785 6.6026 17.7561C6.51629 17.7337 6.43752 17.6887 6.37447 17.6256C6.31142 17.5626 6.26637 17.4838 6.24401 17.3975C6.22164 17.3112 6.22276 17.2205 6.24726 17.1347L6.83934 15.0624L6.8393 15.0625Z",
    stroke: "#DC7835",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11H14",
    stroke: "#DC7835",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H14",
    stroke: "#DC7835",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.48f0e639121fd1ab547c803d3e9f75ca.svg";
export { ForwardRef as ReactComponent };